// Detección automática del entorno basada en la URL actual
const isProduction = () => {
  // Verificar si estamos en producción basado en el hostname
  const hostname = window.location.hostname;
  const isProd = hostname === 'dev.sieguai.com' || 
                //hostname === 'www.sieguai.com' ||
                hostname.includes('dev.sieguai.com');
  
  // También verificar si estamos usando HTTPS (típico en producción)
  const isHttps = window.location.protocol === 'https:';
  
  return isProd || (isHttps && !hostname.includes('localhost'));
};

// Configuración dinámica basada en el entorno
const config = {
  // Detección del entorno
  isProduction: isProduction(),
  environment: isProduction() ? 'production' : 'development',
  
  // URLs de la API
  API_BASE_URL: isProduction() 
    ? 'https://dev.sieguai.com' 
    : 'http://localhost:3000',
  
  // URLs del frontend
  FRONTEND_URL: isProduction()
    ? 'https://dev.sieguai.com'
    : 'http://localhost:3001',
  
  // Configuración adicional
  APP_NAME: 'SIE Guai - Sistema de Integraciones',
  VERSION: '1.0.0',
  
  // Configuración de desarrollo
  DEBUG: !isProduction(),
  
  // Configuración de logs
  LOG_LEVEL: isProduction() ? 'error' : 'debug'
};

// Log de configuración en desarrollo
if (config.DEBUG) {
  console.log('🔧 Configuración del entorno:', {
    environment: config.environment,
    apiUrl: config.API_BASE_URL,
    frontendUrl: config.FRONTEND_URL,
    hostname: window.location.hostname,
    protocol: window.location.protocol
  });
}

export default config; 